<template>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="d-flex">
                <h2 class="text-dark p-5">Publish your legal documents to the world</h2>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-sm-12 col-lg-8 col-md-10 form-container py-4">
                <form enctype="multipart/form-data" @submit.prevent="sendSubmission">
                <div class="custom-file">
                <input type="file" class="custom-file-input"
                accept=".pdf, .txt, .doc, .ppt, .xls, .docx," 
                id="customFile"
                ref="file"
                name="file"
                @change="getFileName"
                required>
                <label class="custom-file-label" for="customFile" >
                   <span v-if="filename">{{filename}}</span> 
                    <span v-else>Select Your File</span>
                    </label>
            </div>
                <p class="text-danger" v-if="pdfError"> {{ pdfError}} </p>
                <p if='success' class="text-success">{{success}}</p>
             <p su></p>
            <button type="submit" class="btn btn-primary px-3 my-4">submit
                <div class="spinner-grow text-danger" role="status"
                 v-if="loading">
                    <span class="sr-only">Loading...</span>
                </div>
            </button>
            </form>
            </div>
        </div>

        <div class="row justify-content-center agreements m-3">
            <div class="">
                <p>Supported file types: pdf, txt, doc, ppt, xls, docx, and more</p>
                <p>By uploading, you agree to our <a href="http://creativecommons.org/" target="_blank" @click="termsAndCondition">Creative Commons Agreement</a></p> 
            </div>
        </div>

    </div>
</template>

<script>
//import vue2Dropzone from 'vue2-dropzone';
//mport 'vue2-dropzone/dist/vue2Dropzone.min.css';

export default{
        props:['id','name'],
        data() {
            return  {
                file:'',
                pdfError:'',
                filename:''
            }
        },
        methods: {
            termsAndCondition() {
            window.open("http://creativecommons.org/")
            },
            getFileName(event) {
                this.filename = event.target.files[0].name
            },
            sendSubmission() {
                    this.file = this.$refs.file.files[0];
                     let formData = new FormData();
                     formData.append('file', this.file)
                     formData.append('category',this.id)
                     this.$store.dispatch('contributor/submitAgreement', formData)
                
            }
  },
  computed:{
      success() {
          return this.$store.state.contributor.success
      },
      loading() {
          return this.$store.state.contributor.loading
      },
      error() {
          return this.$store.state.contributor.error
      }
  }
}
</script>

<style scoped>
.agreements p{
  font-size:0.8em ;
  padding:0 !important;
  margin:0 !important;
}
.form-container{

    border:1px dotted black;
}

</style>